import React from "react";
import { useAuth } from "../auth/AuthContext";
import { formatCurrency } from "../utils/currency";
import { formatQuantity } from "../utils/quantity";

export default function SaleDetailPanel({ sale, onClose }) {
  const { activeShop } = useAuth();
  const currency = (n) => formatCurrency(n, activeShop?.currency);

  return (
    <div className="card stock-panel">
      <div className="stock-panel-header">
        <h2>Sale {sale.receipt_no}</h2>
        <button className="btn btn-secondary" onClick={onClose} type="button">
          Close
        </button>
      </div>
      <div className="stats" style={{ margin: "8px 0 16px" }}>
        <div className="chip">{new Date(sale.created_at).toLocaleString()}</div>
        <div className="chip">{sale.payment_method}</div>
        <div className="chip">{sale.status}</div>
      </div>

      <div className="scroll-x">
        <table className="product-table stock-history-table">
          <thead>
            <tr>
              <th>Product</th>
              <th>Qty</th>
              <th>Unit price</th>
              <th>Discount</th>
              <th>Line total</th>
            </tr>
          </thead>
          <tbody>
            {sale.line_items.map((li) => (
              <tr key={li.id}>
                <td className="name-cell" title={li.product_description || ""}>
                  {li.product_name}
                </td>
                <td>{formatQuantity(li.quantity, undefined)}</td>
                <td>{currency(li.unit_price_at_sale)}</td>
                <td>{currency(li.line_discount)}</td>
                <td>{currency(li.line_subtotal)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="sale-totals">
        <div>Subtotal: {currency(sale.subtotal)}</div>
        <div>Discount: -{currency(sale.discount_total)}</div>
        <div>Tax: +{currency(sale.tax_total)}</div>
        <div className="sale-total-final">Total: {currency(sale.total_amount)}</div>
      </div>
    </div>
  );
}
